import React from 'react';
import { Inline } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OriginDestinationText = _ref => {
  let {
    flightRoute
  } = _ref;
  if (!flightRoute || Object.keys(flightRoute).length === 0) {
    return null;
  }
  const {
    destinationAirportName,
    destinationAirportCode,
    originAirportName,
    originAirportCode
  } = flightRoute || {};
  return /*#__PURE__*/_jsxs(Inline, {
    "aria-hidden": "true",
    spacing: 4,
    children: [/*#__PURE__*/_jsx("span", {
      children: originAirportName
    }), /*#__PURE__*/_jsx("span", {
      children: originAirportCode
    }), /*#__PURE__*/_jsx("span", {
      children: "-"
    }), /*#__PURE__*/_jsx("span", {
      children: destinationAirportName
    }), /*#__PURE__*/_jsx("span", {
      children: destinationAirportCode
    })]
  });
};
//# sourceMappingURL=OriginDestinationText.js.map